<div class="certified-tooltip mt-2">
    @if (params.areAllAssessorsCertified) {
        <span>All assessors are certified.</span>
    }
    @if (!params.areAllAssessorsCertified) {
        <span>
            The following assessors are not certified:
            <div class="certified-list mt-1 mx-3">
                <ul>
                    @for (assessor of params.nonCertifiedAssessors; track assessor) {
                        <li>{{ assessor.assessorName }}</li>
                    }
                </ul>
            </div>
        </span>
    }
</div>

